<template>
  <div class="bdd bdd-single">
    <div class="bddbtn" :class="{ has: isOpen || selected.length }">
      <button
        type="button"
        class="bddmain"
        :aria-expanded="isOpen ? 'true' : 'false'"
        aria-haspopup="listbox"
        @click="toggleDropdown"
        @keydown="onTriggerKey"
      >
        <span>{{ selectedLabel }}</span>
      </button>
      <button type="button" class="bddcar" :aria-label="label" @click="toggleDropdown">▾</button>
    </div>
    <template v-if="isOpen">
      <div class="bdd-back" @click="closeDropdown" />
      <div class="bddmenu" role="listbox" aria-multiselectable="true">
        <div class="bddhead">
          <span>{{ label }}</span>
          <button type="button" class="bddall" @click="clear">Auswahl zurücksetzen</button>
        </div>
        <label v-for="option in options" :key="String(option.value)" class="bdditem">
          <input
            type="checkbox"
            :checked="isSelected(option.value)"
            @change="toggle(option.value)"
          />
          <span>{{ option.label }}</span>
        </label>
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

const props = defineProps({
  label: { type: String, required: true },
  allLabel: { type: String, default: '' },
  options: { type: Array, required: true },
  modelValue: { type: Array, default: () => [] }
});

const emit = defineEmits(['update:modelValue']);
const isOpen = ref(false);

const selected = computed(() => props.modelValue || []);

const selectedLabel = computed(() => {
  if (!selected.value.length) return props.allLabel || props.label;
  if (selected.value.length === 1) {
    const match = props.options.find((option) => String(option.value) === String(selected.value[0]));
    return match ? match.label : props.label;
  }
  return `${selected.value.length} ausgewählt`;
});

function isSelected(value) {
  return selected.value.map(String).includes(String(value));
}

function toggleDropdown() {
  isOpen.value = !isOpen.value;
}

function closeDropdown() {
  isOpen.value = false;
}

function toggle(value) {
  const next = selected.value.map(String);
  const key = String(value);
  const index = next.indexOf(key);
  if (index >= 0) next.splice(index, 1);
  else next.push(key);
  emit('update:modelValue', next);
}

function clear() {
  emit('update:modelValue', []);
}

function onTriggerKey(event) {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    toggleDropdown();
  }
  if (event.key === 'ArrowDown') {
    event.preventDefault();
    isOpen.value = true;
  }
}

function onWindowKey(event) {
  if (event.key === 'Escape') closeDropdown();
}

onMounted(() => {
  window.addEventListener('keydown', onWindowKey);
});

onBeforeUnmount(() => {
  window.removeEventListener('keydown', onWindowKey);
});
</script>
